"use strict";

import React from "react";

const FontAwesome = require("react-fontawesome");
import Followmouse from "./FollowmouseComponent";
import Skill from "./SkillComponent";

//import 'font-awesome/css/font-awesome.min.css';

class HeaderComponent extends React.Component {
    render() {
        const { infos, categories } = this.props;
        // console.log(categories)
        // const skills = categories.map( ({data},i) => {
        //   return <li key={i} >
        //           <Skill title={data.name[0].text} color={data.color[0].text} context="header" />
        //         </li>
        // } )
        return (
            <header>
                <h1>
                    <span className="logo">
                        <Followmouse texte="://" />
                    </span>
                    <span className="name">{infos.title[0].text}</span>
                </h1>
                <nav>
                    <ul>
                        <li>
                            <accr>_D:</accr> DESIGN + CODE
                        </li>
                        <li>
                            <a
                                href="mailto:hello@ahmedghazi.com"
                                target="_blank"
                            >
                                <accr>_M:</accr> hello@ahmedghazi.com
                            </a>
                        </li>
                        <li>
                            <a href="tel:+33661497577" target="_blank">
                                <accr>_T:</accr> +(33)661 497 577
                            </a>
                        </li>
                        <li>
                            <accr>_L:</accr> 75018 Paris
                        </li>
                    </ul>
                </nav>
                <nav className="connecteurs">
                    <accr>_C:</accr>
                    <ul>
                        {infos.infos.map((link, i) => (
                            <li key={i}>
                                <a href={link.url.url} target="_blank">
                                    <FontAwesome name={link.label[0].text} />
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>

                <nav className="skills">
                    <accr>_S:</accr>
                    <ul>
                        {categories.map(({ data }, i) => (
                            <li key={i}>
                                <Skill
                                    title={data.name[0].text}
                                    color={data.color[0].text}
                                    context="header"
                                />
                            </li>
                        ))}
                    </ul>
                </nav>

                <nav className="itw">
                    <accr>_F:</accr>
                    <ul>
                        <li>
                            <a
                                target="_blank"
                                href="https://crazycooldevelopers.github.io/interviews/ahmedghazi/"
                            >
                                crazy cool developers
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                href="https://brutalistwebsites.com/optoopto.eu/"
                            >
                                brutalistwebsites
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                href="https://klikkentheke.com/catalogue/the-skateboard-soundtracks/"
                            >
                                klikkentheke
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                href="https://dumplingbooks.fr/composite/composite-1.html"
                                rel="noopener noreferrer"
                            >
                                la revue composite-
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                href="https://www.wired.it/internet/web/2017/06/20/teleport-me-sito-teletrasporto/"
                            >
                                wired.it
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                href="https://www.theguardian.com/artanddesign/2020/nov/25/sacre-bleu-france-as-youve-never-seen-her-before-atlas-eric-tabuchi-nelly-monnier"
                            >
                                the guardian
                            </a>
                        </li>
                    </ul>
                </nav>
            </header>
        );
    }
}

HeaderComponent.displayName = "HeaderComponent";

// Uncomment properties you need
// HeaderComponent.propTypes = {};
// HeaderComponent.defaultProps = {};

export default HeaderComponent;



// WEBPACK FOOTER //
// ./src/components/HeaderComponent.js